export default {
  state: {
    storeInfo: ''
  },
  getters: {
    getStoreInfo: state => state.storeInfo
  },
  mutations: {
    setStoreInfo (state, data) {
      state.storeInfo = data
    }
  }
}
